import React from "react";
import clsx from "clsx";

import { IconMenu } from "@origin-digital/ods-icons";
import { Box, IconButton, makeStylesSeeded } from "@origin-digital/ods-core";

import { navigationBarHeight } from "../helpers/consts";

const useStyles = makeStylesSeeded(({ palette }) => ({
  menuContainer: {
    display: "flex",
    alignItems: "center",
    height: navigationBarHeight,
    borderRight: `1px solid ${palette.grey["200"]}`,
    paddingRight: 16,
    '& [class*="MuiIconButton-root"]': {
      background: "transparent",
      padding: 0,
      "& svg": {
        fontSize: 28,
      },
    },
  },
}));

interface IKrakenHamburger {
  onClick: (event: React.KeyboardEvent | React.MouseEvent) => void;
  "data-id": string;
}

export const MenuHamburger = (props: IKrakenHamburger) => {
  const styles = useStyles();
  return (
    <Box className={clsx(styles.menuContainer)}>
      <IconButton {...props}>
        <IconMenu tone="neutral" />
      </IconButton>
    </Box>
  );
};
